/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */


import {Store, ComputedSignal, Signal} from '@gongxigames/framework/core';
import {FC, $Container, $GraphicsBox, CanBeSignals, CanBeSignal, Trigger, getProp, mapProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
import {$RubyUIText} from '@gongxigames/framework/slotV2/ui/ui-ruby/JSX/RubyUIText';

export type Label<T = string> = {
    localeId?: string
    val: Signal<T>
    enabled: Signal<boolean>,
}

export type LabelsPrimary = {
    gameName: Label
    clock: Label
}

export type LabelsSecondary = {
    pointsBalance: Label, // Modo winnings
    elapsedTime: Label,
    netPosition: Label,
    sessionEarnings: Label,
    sessionBets: Label,
    showMaxWinProbability: Label,
    RTPWatermark: Label<number>,
}

export type JurisdictionZoneMainProps = {
    jurisdictionZoneHeight: CanBeSignal<number>;
    labelsPrimary: LabelsPrimary;
    labelsSecondary: LabelsSecondary;
};

export const $JurisdictionZoneMain: FC<JurisdictionZoneMainProps> = (props) => {
    const jurisdictionZonePosition: ComputedSignal<ResponsiveConf> = mapProp(props.jurisdictionZoneHeight, height => ({
        box: {width: '100%', height: `${height}px`, y: '100%'},
        translate: {y: '-100%'}
    }));

    return <$GraphicsBox
            name='jurisdiction_zone'
            responsive={jurisdictionZonePosition}
            responsiveBoxSize
            boxColor={0x000}
            boxAlpha={0.7}
        >
            <$RubyUIText
                localeID='gameName'
                responsive={{box: {x: '50px', y: '8px'}}}
                stylePreset='JURISDICTION_ZONE'
                text={props.labelsPrimary.gameName.val}
                style={{align: 'left', verticalAlign: 'top'}}
                />
            <$RubyUIText
                localeID='clock'
                responsive={{box: {x: '100%', y: '8px'}, translate: {x: '-50px'}}}
                stylePreset='JURISDICTION_ZONE'
                text={props.labelsPrimary.clock.val}
                style={{align: 'right', verticalAlign: 'top'}}
            />
        </$GraphicsBox>;
};